
import { Component, Inject, Prop, Vue } from "vue-property-decorator";

@Component({ name: 'FormElement' })
export default class FormElement extends Vue {
  @Prop() public disabledTooltip?: string;
}
